module.exports = __webpack_public_path__ + "static/media/consumoemisiones.e10f546c.svg";